<template>
    <div class="card p-10">
    <h3>Captura de huellas dactilares de {{nombre}}</h3>
    <div class="card-hand">
      <hands-component @send-fingerprintvalue="getFingerPrint"></hands-component>
    </div>
    <div class="barra_right" @click="toggleDivManoDerecha" data-bs-toggle="collapse" data-bs-target="#collapse_right">
      <span>{{ mostrarDivManoDerecha ? 'Ocultar Huellas Dactilares Mano Derecha' : 'Mostrar Huellas Dactilares Mano Derecha' }}</span>
    </div>
    <div  class="collapse" id="collapse_right">
      <div class="row d-flex justify-content-center">
      <div v-for="(finger, index) in fingerPrintRight" :key="index"
          class="row col-md-2 mx-5">
          <finger-print :name='finger.name' :fingerprint='finger.fingerPrint'></finger-print>
      </div>
    </div>
    </div>
    <div class="barra_left" @click="toggleDivManoIzquierda" data-bs-toggle="collapse" data-bs-target="#collapse_left">
      <span>{{ mostrarDivManoIzquierda ? 'Ocultar Huellas Dactilares Mano Izquierda' : 'Mostrar Huellas Dactilares Mano Izquierda' }}</span>
    </div>
    <div  class="collapse" id="collapse_left">
      <div class="row d-flex justify-content-center">
      <div v-for="(finger, index) in fingerPrintLeft" :key="index"
          class="row col-md-2 mx-5">
          <finger-print :name='finger.name' :fingerprint='finger.fingerPrint'></finger-print>
      </div>
    </div>
    </div>
<div class="d-flex justify-content-end my-2">
  <button :disabled ="isDisabled<10" class="btn btn-success" @click="saveFingerPrints">Enviar</button>
</div>
</div>
<loading
    v-model:active="isLoading"
    :can-cancel="false"
    :is-full-page="true"
    loader="bars"
    :height="100"
    :width="100"
  ></loading>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { defineComponent, ref, reactive, onMounted, computed } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { useRoute,useRouter } from "vue-router";
import handsComponent from '@/views/filiation/handsComponent.vue';
import fingerPrint from "@/views/filiation/fingerPrint.vue";
import filiation from "@/filiation/composables/useFiliation";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
export default defineComponent({
  name: "upload_finger_prints",
  components: {
    handsComponent,
    fingerPrint,
    Loading
  },
  setup(){
      const route = useRoute();
      const router = useRouter();
      const nombre= ref(null);
      const id=ref(null);
      const isLoading = ref(false);
      const { uploadFingerPrints } = filiation();
      const fingerNames = reactive([
        {id:'little_right', name: 'Meñique derecho', fingerPrint:''},{id:'ring_right', name: 'Anular derecho' , fingerPrint:''},
        {id:'middle_right', name: 'Medio derecho' , fingerPrint:''},{id:'index_right', name: 'Índice derecho' , fingerPrint:''},
        {id:'thumb_right', name: 'Pulgar derecho' , fingerPrint:''},
        {id:'thumb_left', name: 'Pulgar izquierdo' , fingerPrint:''},{id:'index_left', name: 'Índice izquierdo' , fingerPrint:''},
        {id:'middle_left', name: 'Medio izquierdo' , fingerPrint:''},{id:'ring_left', name: 'Anular izquierdo' , fingerPrint:''},
        {id:'little_left', name: 'Meñique izquierdo' , fingerPrint:''}
      ]);
      const getFingerPrint = async (value) =>{
        const found = fingerNames.find((element) => element.id === value.id_finger);
        found.fingerPrint = value.huella
        
      }
      const saveFingerPrints = async () =>{
        // console.log("id", id.value);
        // console.log("fingerNames",fingerNames);
        try {
            isLoading.value=true;
            const val = []
            for (let index = 0; index < fingerNames.length; index++) {
              const fingerPrint = fingerNames[index].fingerPrint;
              const fingerPrintId = fingerNames[index].id;
              val.push({finger: fingerPrint, id:fingerPrintId})
            }
            const { data } = await uploadFingerPrints({
              fingerprints: val,
              id_persona: id.value,
            });
            if (data.ok) {
                isLoading.value=false
                Swal.fire({
                  title: "¡Realizado!",
                  text: `Las huellas dactilares fueron almacenadas con éxito`,
                  icon: "success",
                  buttonsStyling: false,
                  confirmButtonText: "Continuar",
                  customClass: {
                    confirmButton: "btn fw-bold btn-light-primary",
                  },
                });
                router.push({name:"listDeprivedLibertybyPrisons"})
      }
        } catch (error) {
          isLoading.value=false;   
          Swal.fire({
                  title: "Error!",
                  text: `Las huellas dactilares no fueron almacenadas`,
                  icon: "error",
                  buttonsStyling: false,
                  confirmButtonText: "Continuar",
                  customClass: {
                    confirmButton: "btn fw-bold btn-light-primary",
                  },
                });       
        }

      }
      const fingerPrintRight = computed (()=>{
        const filteredArray = fingerNames.filter(obj => {
        // Verificar si la propiedad finger_left contiene la palabra "left"
        return obj.id.includes("right");
        });
        return filteredArray
      })
      const fingerPrintLeft = computed (()=>{
        const filteredArray = fingerNames.filter(obj => {
        // Verificar si la propiedad finger_left contiene la palabra "left"
        return obj.id.includes("left");
        });
        return filteredArray
      })
      const mostrarDivManoDerecha = ref(false);
      const toggleDivManoDerecha = () => {
        mostrarDivManoDerecha.value = !mostrarDivManoDerecha.value;
      };
      const mostrarDivManoIzquierda = ref(false);
      const toggleDivManoIzquierda = () => {
        mostrarDivManoIzquierda.value = !mostrarDivManoIzquierda.value;
      };
      const isDisabled = computed(()=>{
        let finger = 0;
        fingerNames.forEach((element) => {
          if(element.fingerPrint){
            finger =finger+1
          }
          }
        );
        return finger
      })
      onMounted(() => {
        // if(!route.params.id_persona){
        //   router.push({name:"listDeprivedLibertybyPrisons"})
        // }
        // else{
          const {nombre_ppl, id_persona} = route.params;
          nombre.value = nombre_ppl;
          id.value = id_persona
      // }
        setCurrentPageBreadcrumbs("Huellas Dactilares", [
          "Información Privado de libertad",
        ]);
      });
      return{
         nombre,
         fingerNames,
         getFingerPrint,
         isDisabled,
         isLoading,
         saveFingerPrints,
         fingerPrintRight,
         fingerPrintLeft,
         mostrarDivManoDerecha,
         mostrarDivManoIzquierda,
         toggleDivManoDerecha,
         toggleDivManoIzquierda
      }
    },
})
</script>
<style scoped>
.card-hand{
  background-color: lightgray;
  padding: 20px;
}
.barra_right {
  background-color: #007bff;
  color: white;
  padding: 10px;
  cursor: pointer;
}
.barra_left {
  background-color: #7ab8fa;
  color: white;
  padding: 10px;
  cursor: pointer;
}
</style>